const classContent = [
    {
      image: "classCarousel-1.png"
    },
    {
      image: "classCarousel-2.png"
    }
  ];

  export default classContent;